module.exports = __webpack_public_path__ + "img/benefits_personal.953a08d.svg?v=1747398688961";